import { FC } from 'react';
import ResultCard from '@components/phs/pst/results/result/common/resultCard';
import Tooltip from '@components/phs/pst/results/result/common/tooltip';
import AchievementGrade from '@components/phs/pst/results/result/gradeInfo/achievementGrade';
import GradeList from '@components/phs/pst/results/result/gradeInfo/gradeList';
import GradeButtons from '@components/phs/pst/results/result/gradeInfo/gradeButtons';
import GradeDesc from '@components/phs/pst/results/result/gradeInfo/gradeDesc';
import { PstResultVO } from '@domain/vo/phs/pst/result/PstResultVO';
import classnames from 'classnames/bind';
import styles from './gradeInfo.module.scss';

const cx = classnames.bind(styles);

const ToolTipContent = () => {
  return (
    <div className={cx('tooltipArea')}>
      <strong className={cx('tooltipTitle')}>달성 등급이란?</strong>
      <span className={cx('tooltipDesc')}>
        응시한 문제의 난이도와 채점 결과에 따라 특정 등급을 달성할 수 있습니다.
        <br />
        높은 등급을 달성할수록 매칭 가능한 기업이 많아집니다.
      </span>
    </div>
  );
};

interface GradeInfoProps {
  pstResult: PstResultVO;
}

const GradeInfo: FC<GradeInfoProps> = ({ pstResult }) => {
  const { version, grade } = pstResult;

  if (!grade) return null;

  return (
    <ResultCard
      title={'달성 등급'}
      cardType={'gray'}
      iconType={'grade'}
      toolTip={<Tooltip content={<ToolTipContent />} />}
    >
      <div>
        {/* 등급 목록 */}
        <GradeList grade={grade} />

        {/* 달성 등급, 설명 */}
        <AchievementGrade version={version} grade={grade} />

        {/* 도움말 */}
        <GradeDesc version={version} />

        {/* 버튼 */}
        <GradeButtons />
      </div>
    </ResultCard>
  );
};

export default GradeInfo;
